// extracted by mini-css-extract-plugin
export default {"challengeList":"challanges_challengeList__vZXkF","challengeItem":"challanges_challengeItem__Jvl4c","challengeHeader":"challanges_challengeHeader__ig2AZ"};